// extracted by mini-css-extract-plugin
module.exports = {"box":"ErrorModal_box__EVxni","title":"ErrorModal_title__yVRar","wrapper":"ErrorModal_wrapper__2tujS"};